import { useState } from 'react';
import { ConfirmModal, ListPageLayout } from '@practium/ui';
import { PlanReferenceCard } from '@/features/parameters/components/Cards/PlanReferenceCard';
import { StateReferenceCard } from '@/features/parameters/components/Cards/StateReferenceCard';
import { PlanSidebar } from '@/features/parameters/components/Sidebar/PlanSidebar/PlanSidebar';
import { RegionsSidebar } from '@/features/parameters/components/Sidebar/RegionsSidebar/RegionsSidebar';
import { ViewSwitch } from '@/features/parameters/components/Sidebar/ViewSwitch/ViewSwitch';
import { useParametersPage } from '@/features/parameters/hooks/useParametersPage';

export const ParametersPage = () => {
	const { view, setView, states, plan, confirmModal } = useParametersPage();
	const [isCreateOpen, setIsCreateOpen] = useState(false);
	const [isCreatePlanOpen, setIsCreatePlanOpen] = useState(false);
	const viewSwitch = <ViewSwitch view={view} onChange={setView} />;

	return (
		<>
			<ListPageLayout
				sidebarWidth="28rem"
				sidebarW1500="22rem"
				sidebarW1300="19rem"
				sidebarW1200="17rem"
				sidebar={
					view === 'states' ? (
						<RegionsSidebar
							references={states.references}
							selected={states.selected}
							isLoading={states.isLoading}
							isCreateModalOpen={isCreateOpen}
							viewSwitch={viewSwitch}
							onSelect={states.selectReference}
							onCreate={states.createRegion}
							onUpdate={states.updateRegion}
							onDelete={states.deleteRegion}
							onCloseCreateModal={() => setIsCreateOpen(false)}
						/>
					) : (
						<PlanSidebar
							plans={plan.plans}
							plan={plan.plan}
							isLoading={plan.isLoading}
							isSaving={plan.isSaving}
							isCreateModalOpen={isCreatePlanOpen}
							viewSwitch={viewSwitch}
							onSelect={plan.selectPlan}
							onSave={plan.savePlan}
							onCreate={plan.createPlan}
							onActivate={plan.activatePlan}
							onDelete={plan.deletePlan}
							onCloseCreateModal={() => setIsCreatePlanOpen(false)}
						/>
					)
				}
			>
				{view === 'states' ? (
					<StateReferenceCard
						reference={states.selected}
						section={states.section}
						isLoading={states.isLoading}
						isError={states.isError}
						isSaving={states.isSaving}
						onSectionChange={states.setSection}
						onNewRegion={() => setIsCreateOpen(true)}
						onSave={states.saveSection}
						onConfirmDelete={states.confirmDelete}
					/>
				) : (
					<PlanReferenceCard
						plan={plan.plan}
						section={plan.section}
						isLoading={plan.isLoading}
						isError={plan.isError}
						isSaving={plan.isSaving}
						onSectionChange={plan.setSection}
						onNewPlan={() => setIsCreatePlanOpen(true)}
						onSave={plan.savePlan}
					/>
				)}
			</ListPageLayout>

			<ConfirmModal
				isOpen={confirmModal.isOpen}
				title={confirmModal.options.title}
				message={confirmModal.options.message}
				confirmText={confirmModal.options.confirmText}
				cancelText={confirmModal.options.cancelText}
				variant={confirmModal.options.variant}
				onConfirm={confirmModal.handleConfirm}
				onCancel={confirmModal.handleCancel}
			/>
		</>
	);
};
